import { AxiosError, AxiosResponse } from 'axios';
import { useQueryClient, useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

function useAthleteWodupStatus(): UseMutationResult<
  AxiosResponse<{}>,
  AxiosError<ErrorMessage>,
  {
    athleteId: string;
    activate: boolean;
  }
> {
  const queryClient = useQueryClient();

  const createAthlete = ({
    athleteId,
    activate,
  }: {
    athleteId: string;
    activate: boolean;
  }): Promise<AxiosResponse<{}>> => {
    return client.post(`athletes/${athleteId}/wodup-status/`, { activate });
  };

  return useMutation(createAthlete, {
    onSuccess: () => {
      queryClient.invalidateQueries('athletes');
    },
  });
}

export default useAthleteWodupStatus;
